import React from "react";
import useTimeInputService from "./service";
import { CustomTimePickerProps, ExtendedCustomTimePickerProps } from "./types";
import RenderScrollableSelectOption from "./components/scrollableSelectOption";

/**
 * Timepicker in MUI style
 */
export function ScrollableTimePicker(props: CustomTimePickerProps) {
  const service = useTimeInputService(props as ExtendedCustomTimePickerProps);

  return (
    <div className="scrollableTimePicker">
      <RenderScrollableSelectOption
        testId={"hourSelector"}
        className="scrollableTimePicker_column--hours"
        options={service.hourOptions}
        value={service.hourDisplayValue}
        selectedDate={props.selectedDate}
        onChange={service.hourChangeHandler}
      />
      <RenderScrollableSelectOption
        testId={"minuteSelector"}
        className="scrollableTimePicker_column--minutes"
        options={service.minuteOptions}
        value={service.minuteValue}
        selectedDate={props.selectedDate}
        onChange={service.minuteChangeHandler}
      />
      <RenderScrollableSelectOption
        testId={"timeFormatSelector"}
        className="scrollableTimePicker_column--timeformat"
        options={service.timeFormatOptions}
        value={service.timeFormat}
        selectedDate={props.selectedDate}
        onChange={service.timeFormatChangeHandler}
      />
    </div>
  );
}
